import React from "react";
import "./formbuilder.tailwind.css";
import FormCard from "./FormCard.jsx";

const DEFAULT_FORM_PROPS = {
  title: "Nuevo formulario",
  subtitle: "",
  header: "true",
  card: "true",
  close: "false",
  icon_data_url: "",
  html_header: "",
  scheduling: "false",
  notification: "false",
  editable: "false",
  dark: "false",
  submit: "true",
  scheduled_time: "",
  result_value: "",
  color: "",
  background_color: "",
  height: "60vh",
  scheduling_value: null,
  notification_value: null,
};

const STRIPPED_FORM_PROPS = new Set([
  "save",
  "postpone",
  "fields_value",
  "icon",
  "programacion",
  "notificacion",
  "notificar",
]);

function stripFormProps(raw) {
  if (!raw || typeof raw !== "object") return {};
  const next = { ...raw };
  STRIPPED_FORM_PROPS.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(next, key)) {
      delete next[key];
    }
  });
  return next;
}

const FIELD_GROUPS = [
  {
    id: "layout",
    title: "Diseño",
    description: "Definen estructura, no generan valor.",
    items: [
      { id: "tab", label: "Pestaña", template: { type: "tab", tab: "Seccion" } },
      { id: "layout-1", label: "Diseño 1", template: { type: "layout-1" } },
      { id: "layout-2", label: "Diseño 2", template: { type: "layout-2" } },
      { id: "layout-3", label: "Diseño 3", template: { type: "layout-3" } },
      {
        id: "layout-free",
        label: "Diseño libre",
        template: { type: "layout-free", options: ["50%", "50%"] },
      },
    ],
  },
  {
    id: "visual",
    title: "Visual",
    description: "Solo lectura, no generan entradas.",
    items: [
      { id: "title", label: "Título", template: { type: "title", text: "Titulo" } },
      { id: "subtitle", label: "Subtítulo", template: { type: "subtitle", text: "Subtitulo" } },
      { id: "textView", label: "Vista de texto", template: { type: "textView", text: "Texto informativo" } },
      { id: "htmlview", label: "HTML", template: { type: "htmlview", html: "<strong>HTML</strong>" } },
      { id: "divider", label: "Separador", template: { type: "divider" } },
      {
        id: "imageview",
        label: "Vista de imagen",
        template: {
          type: "imageview",
          images: [
            "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=800&q=80",
            "https://images.unsplash.com/photo-1526256262350-7da7584cf5eb?w=800&q=80",
            "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=800&q=80",
          ],
        },
      },
      {
        id: "videoview",
        label: "Vista de vídeo",
        template: {
          type: "videoview",
          url: "https://storage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
        },
      },
    ],
  },
  {
    id: "text-number",
    title: "Entradas",
    description: "Entradas básicas.",
    items: [
      { id: "text", label: "Texto", template: { type: "text", name: "texto", caption: "Texto", placeholder: "Escriba aqui" } },
      { id: "number", label: "Número", template: { type: "number", name: "numero", caption: "Numero", placeholder: "0" } },
      { id: "date", label: "Fecha", template: { type: "date", name: "fecha", caption: "Fecha", placeholder: "AAAA-MM-DD" } },
      { id: "time", label: "Hora", template: { type: "time", name: "hora", caption: "Hora", placeholder: "HH:MM" } },
      {
        id: "datetime",
        label: "Fecha y hora",
        template: { type: "datetime", name: "fecha_hora", caption: "Fecha y hora", placeholder: "AAAA-MM-DD HH:MM" },
      },
      { id: "memo", label: "Observaciones", template: { type: "memo", name: "memo", caption: "Observaciones", placeholder: "Detalle..." } },
    ],
  },
  {
    id: "selection",
    title: "Selección",
    description: "Campos de elección.",
    items: [
      {
        id: "options",
        label: "Opciones",
        template: { type: "options", name: "opcion", caption: "Opciones", options: ["Opcion A", "Opcion B", "Opcion C"] },
      },
      {
        id: "singlelist",
        label: "Lista simple",
        template: { type: "singlelist", name: "lista", caption: "Lista simple", options: ["Uno", "Dos", "Tres"] },
      },
      {
        id: "multiplelist",
        label: "Lista múltiple",
        template: { type: "multiplelist", name: "lista_multiple", caption: "Lista multiple", options: ["A", "B", "C"] },
      },
      { id: "bool", label: "Sí/No", template: { type: "bool", name: "bool", caption: "Si o no" } },
      { id: "slider", label: "Deslizador", template: { type: "slider", name: "slider", caption: "Slider", options: ["Bajo", "Medio", "Alto"] } },
      { id: "rating", label: "Valoración", template: { type: "rating", name: "rating", caption: "Calificacion" } },
      { id: "pain", label: "Dolor", template: { type: "pain", name: "dolor", caption: "Dolor" } },
      {
        id: "selector",
        label: "Selector",
        template: {
          type: "selector",
          name: "selector",
          caption: "Selector",
          options: [
            "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=400&q=80",
            "https://images.unsplash.com/photo-1526256262350-7da7584cf5eb?w=400&q=80",
            "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=400&q=80",
          ],
        },
      },
    ],
  },
  {
    id: "media",
    title: "Multimedia",
    description: "Captura o selecciona archivos.",
    items: [
      { id: "image", label: "Imagen", template: { type: "image", name: "imagen", caption: "Imagen", source: "upload" } },
      { id: "video", label: "Vídeo", template: { type: "video", name: "video", caption: "Video", seconds: 8 } },
      { id: "attach", label: "Adjunto", template: { type: "attach", name: "adjunto", caption: "Adjuntar", extensions: "jpg,pdf" } },
    ],
  },
  {
    id: "action",
    title: "Acción",
    description: "Dispara una operación sin valor.",
    items: [
      { id: "code", label: "Código", template: { type: "code", name: "codigo", caption: "Leer codigo" } },
      { id: "adder", label: "Añadir", template: { type: "adder", caption: "Agregar", adderGroup: "" } },
    ],
  },
];

const FIELD_ITEM_MAP = FIELD_GROUPS.reduce((acc, group) => {
  group.items.forEach((item) => {
    acc[item.id] = item;
  });
  return acc;
}, {});

const TYPE_LABELS = {
  tab: "Pestaña",
  "layout-1": "Diseño 1",
  "layout-2": "Diseño 2",
  "layout-3": "Diseño 3",
  "layout-free": "Diseño libre",
  title: "Título",
  subtitle: "Subtítulo",
  textView: "Vista de texto",
  htmlview: "HTML",
  divider: "Separador",
  imageview: "Vista de imagen",
  videoview: "Vista de vídeo",
  text: "Texto",
  number: "Número",
  date: "Fecha",
  time: "Hora",
  datetime: "Fecha y hora",
  memo: "Observaciones",
  options: "Opciones",
  singlelist: "Lista simple",
  multiplelist: "Lista múltiple",
  bool: "Sí/No",
  slider: "Deslizador",
  rating: "Valoración",
  pain: "Dolor",
  selector: "Selector",
  image: "Imagen",
  video: "Vídeo",
  attach: "Adjunto",
  code: "Código",
  adder: "Añadir",
};

function getTypeLabel(type) {
  if (!type) return "";
  return TYPE_LABELS[type] || type;
}

const OPTION_LIST_TYPES = new Set(["options", "singlelist", "multiplelist", "slider"]);
const IMAGE_LIST_TYPES = new Set(["selector"]);
const TEXT_ONLY_TYPES = new Set(["title", "subtitle", "textView"]);
const RANGE_TYPES = new Set(["number", "date", "time", "datetime"]);
const VALUE_FIELD_TYPES = new Set([
  "text",
  "number",
  "date",
  "time",
  "datetime",
  "memo",
  "options",
  "singlelist",
  "multiplelist",
  "bool",
  "slider",
  "rating",
  "pain",
  "selector",
  "image",
  "video",
  "attach",
]);
const BEHAVIOUR_DEFAULT = "LEER Y ESCRIBIR";
const BEHAVIOUR_ALLOWED_VALUES = new Set(["LEER Y ESCRIBIR", "LEER", "OCULTO"]);
const BEHAVIOUR_OPTIONS = [
  { value: "LEER Y ESCRIBIR", label: "LEER Y ESCRIBIR" },
  { value: "LEER", label: "LEER" },
  { value: "OCULTO", label: "OCULTO" },
];
const GROUP_EXCLUDED_TYPES = new Set(["imageview", "videoview"]);
const GROUP_FIELD_TYPES = new Set(
  [
    ...VALUE_FIELD_TYPES,
    "title",
    "subtitle",
    "textView",
    "htmlview",
    "divider",
    "adder",
    "code",
    "layout-1",
    "layout-2",
    "layout-3",
    "layout-free",
    "tab",
  ].filter((type) => !GROUP_EXCLUDED_TYPES.has(type))
);
function normalizeFieldGroup(field) {
  if (!field || typeof field !== "object") return field;
  const next = { ...field };
  if (!GROUP_FIELD_TYPES.has(next.type)) {
    if (Object.prototype.hasOwnProperty.call(next, "group")) {
      delete next.group;
    }
    return next;
  }
  if (next.adderGroup !== undefined && next.adderGroup !== null && String(next.adderGroup).trim() !== "") {
    next.adderGroup = String(next.adderGroup);
    if (Object.prototype.hasOwnProperty.call(next, "group")) {
      delete next.group;
    }
    return next;
  }
  if (Object.prototype.hasOwnProperty.call(next, "group")) {
    delete next.group;
  }
  next.adderGroup = "";
  return next;
}

function normalizeBehaviourValue(value) {
  if (typeof value !== "string") return BEHAVIOUR_DEFAULT;
  const normalized = value.trim().toUpperCase().replace(/\s+/g, " ");
  if (BEHAVIOUR_ALLOWED_VALUES.has(normalized)) return normalized;
  return BEHAVIOUR_DEFAULT;
}

function normalizeFieldBehaviours(field) {
  if (!field || typeof field !== "object") return field;
  if (!field.type) return field;
  const next = { ...field };
  next.behaviourUsuario = normalizeBehaviourValue(next.behaviourUsuario);
  next.behaviourProfesional = normalizeBehaviourValue(next.behaviourProfesional);
  if (Object.prototype.hasOwnProperty.call(next, "who")) {
    delete next.who;
  }
  return next;
}

function cloneTemplate(template) {
  return JSON.parse(JSON.stringify(template));
}

function collectNames(fields) {
  return new Set(fields.map((field) => field && field.name).filter(Boolean));
}

function makeUniqueName(base, used) {
  if (!base) return "campo";
  let candidate = base;
  let idx = 2;
  while (used.has(candidate)) {
    candidate = `${base}_${idx}`;
    idx += 1;
  }
  used.add(candidate);
  return candidate;
}

function nextTabLabel(fields) {
  const count = fields.filter((field) => field && field.type === "tab").length + 1;
  return `Seccion ${count}`;
}

function buildFieldFromPalette(item, fields, nextId) {
  const usedNames = collectNames(fields);
  const field = cloneTemplate(item.template);
  if (field.type === "tab" && !field.tab) {
    field.tab = nextTabLabel(fields);
  }
  if (field.name) {
    field.name = makeUniqueName(field.name, usedNames);
  }
  if (field.type === "video" && Object.prototype.hasOwnProperty.call(field, "value")) {
    delete field.value;
  }
  field._id = nextId;
  return normalizeFieldBehaviours(normalizeFieldGroup(field));
}

function getFieldLabel(field) {
  if (!field) return "Campo";
  if (field.type === "tab") return `Pestaña: ${field.tab || "Sección"}`;
  if (field.type === "layout-1") return "Diseño 1";
  if (field.type === "layout-2") return "Diseño 2";
  if (field.type === "layout-3") return "Diseño 3";
  if (field.type === "layout-free") return "Diseño libre";
  if (field.type === "divider") return "Separador";
  if (field.type === "adder") return `Añadir: ${field.caption || "Añadir"}`;
  if (TEXT_ONLY_TYPES.has(field.type)) return field.text || "Texto";
  if (field.type === "htmlview") return "HTML";
  if (field.type === "imageview") return "Vista de imagen";
  if (field.type === "videoview") return "Vista de vídeo";
  if (field.caption) return field.caption;
  if (field.name) return field.name;
  return field.type || "Campo";
}

function isControlField(field) {
  if (!field) return false;
  return (
    field.type === "layout-1" ||
    field.type === "layout-2" ||
    field.type === "layout-3" ||
    field.type === "layout-free" ||
    field.type === "tab"
  );
}

function getGroupValue(value) {
  if (value === undefined || value === null) return "";
  const trimmed = String(value).trim();
  return trimmed;
}

function isGroupCloneEligible(field) {
  if (!field) return false;
  if (field.type === "adder") return false;
  if (field.type === "imageview" || field.type === "videoview") {
    return false;
  }
  if (
    field.type === "title" ||
    field.type === "subtitle" ||
    field.type === "textView" ||
    field.type === "htmlview" ||
    field.type === "divider"
  ) {
    return true;
  }
  if (
    field.type === "layout-1" ||
    field.type === "layout-2" ||
    field.type === "layout-3" ||
    field.type === "layout-free" ||
    field.type === "tab"
  ) {
    return true;
  }
  return Boolean(field.name);
}

function shouldInheritAdderGroup(field) {
  if (!field) return false;
  if (field.type === "adder") return false;
  return GROUP_FIELD_TYPES.has(field.type);
}

function findNextAdderGroup(fieldsList, startIndex) {
  if (!Array.isArray(fieldsList)) return "";
  for (let i = Math.max(0, startIndex || 0); i < fieldsList.length; i += 1) {
    const field = fieldsList[i];
    if (field && field.type === "adder") {
      return getGroupValue(field.adderGroup);
    }
  }
  return "";
}

function getNextCloneIndex(baseName, fieldsList, cache) {
  if (!baseName) return 1;
  if (cache.has(baseName)) {
    const nextIndex = cache.get(baseName) + 1;
    cache.set(baseName, nextIndex);
    return nextIndex;
  }
  let maxIndex = 0;
  const pattern = new RegExp(`^${baseName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}_(\\d+)$`);
  for (const field of fieldsList) {
    if (!field || !field.name) continue;
    if (field.name === baseName) {
      if (maxIndex < 1) maxIndex = 1;
    }
    const match = field.name.match(pattern);
    if (match) {
      const idx = Number(match[1]);
      if (Number.isFinite(idx) && idx > maxIndex) maxIndex = idx;
    }
  }
  const nextIndex = Math.max(2, maxIndex + 1);
  cache.set(baseName, nextIndex);
  return nextIndex;
}

function cloneFieldsForAdderBuilder(fieldsList, adderField, groupId, nextIdFn) {
  const groupValue = getGroupValue(adderField && adderField.adderGroup);
  if (!groupValue) return null;
  const adderIndex = fieldsList.findIndex((field) => field && field._id === adderField._id);
  if (adderIndex === -1) return null;
  const candidates = [];
  for (let i = 0; i < adderIndex; i += 1) {
    const field = fieldsList[i];
    if (!isGroupCloneEligible(field)) continue;
    if (getGroupValue(field.adderGroup) !== groupValue) continue;
    candidates.push(field);
  }
  if (!candidates.length) return null;
  const indexCache = new Map();
  const clones = candidates.map((field) => {
    const baseName = field.name;
    const nextIndex = baseName ? getNextCloneIndex(baseName, fieldsList, indexCache) : null;
    const cloned = {
      ...field,
      _id: nextIdFn(),
      __adderClone: true,
      __adderGroupId: groupId,
    };
    if (baseName) {
      cloned.name = `${baseName}_${nextIndex}`;
      cloned.__adderBaseName = baseName;
    }
    if (Object.prototype.hasOwnProperty.call(cloned, "value")) {
      delete cloned.value;
    }
    if (Object.prototype.hasOwnProperty.call(cloned, "adderGroup")) {
      delete cloned.adderGroup;
    }
    return cloned;
  });
  const layoutStart = { type: "layout-1", _id: nextIdFn(), __adderGroupId: groupId };
  const divider = { type: "divider", _id: nextIdFn(), __adderGroupId: groupId };
  const nextFields = [...fieldsList];
  nextFields.splice(adderIndex, 0, layoutStart, divider, ...clones);
  return nextFields;
}

function renumberBuilderCloneNames(fieldsList) {
  const counters = new Map();
  return fieldsList.map((field) => {
    if (!field || !field.__adderBaseName) return field;
    const baseName = field.__adderBaseName;
    const nextIndex = (counters.get(baseName) || 1) + 1;
    counters.set(baseName, nextIndex);
    const nextName = `${baseName}_${nextIndex}`;
    if (field.name === nextName) return field;
    return { ...field, name: nextName };
  });
}

function sanitizeFieldForExport(field) {
  if (!field || typeof field !== "object") return field;
  const next = normalizeFieldBehaviours(normalizeFieldGroup({ ...field }));
  if (next.__adderClone || next.__adderBaseName) {
    if (Object.prototype.hasOwnProperty.call(next, "adderGroup")) {
      delete next.adderGroup;
    }
  }
  if (Object.prototype.hasOwnProperty.call(next, "__adderClone")) delete next.__adderClone;
  if (Object.prototype.hasOwnProperty.call(next, "__adderGroupId")) delete next.__adderGroupId;
  if (Object.prototype.hasOwnProperty.call(next, "__adderBaseName")) delete next.__adderBaseName;
  return next;
}

function parseDragData(event) {
  const raw = event.dataTransfer.getData("text/plain");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
}

function normalizeList(value) {
  if (!Array.isArray(value)) return [];
  return value.map((item) => String(item).trim()).filter(Boolean);
}

function listToText(list) {
  return normalizeList(list).join("\n");
}

function textToList(text) {
  return String(text)
    .split(/\r?\n/)
    .map((item) => item.trim())
    .filter(Boolean);
}

function deriveNextId(fields) {
  let maxId = 0;
  fields.forEach((field) => {
    if (!field || typeof field._id !== "string") return;
    const matches = field._id.match(/\d+/g);
    if (!matches || matches.length === 0) return;
    const last = Number(matches[matches.length - 1]);
    if (Number.isFinite(last) && last > maxId) {
      maxId = last;
    }
  });
  return maxId + 1;
}

function isValidHexColor(value) {
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  const hex = trimmed.startsWith("#") ? trimmed.slice(1) : trimmed;
  if (!/^[0-9a-fA-F]+$/.test(hex)) return false;
  return hex.length === 3 || hex.length === 6;
}

function normalizeHexColor(value, fallback = "#000000") {
  if (!isValidHexColor(value)) return fallback;
  const trimmed = value.trim();
  if (trimmed.startsWith("#")) return trimmed;
  if (trimmed.length === 3) {
    return `#${trimmed[0]}${trimmed[0]}${trimmed[1]}${trimmed[1]}${trimmed[2]}${trimmed[2]}`;
  }
  return `#${trimmed}`;
}

function isTrueValue(value) {
  if (value === true) return true;
  if (typeof value === "string") return value.toLowerCase() === "true";
  return false;
}

function FieldInput({ label, children }) {
  return (
    <label className="grid gap-1 text-xs font-semibold text-slate-600">
      <span>{label}</span>
      {children}
    </label>
  );
}

export default function FormBuilder(props = {}) {
  const {
    value,
    onChange,
    hideHeader = false,
    hideToolbar = false,
    embedded = false,
    className = "",
    style,
  } = props;
  const hasControlledValue = value !== undefined;
  const externalValueRef = React.useRef(null);
  const lastEmittedRef = React.useRef(null);
  const hasInitializedRef = React.useRef(!hasControlledValue);

  const [fields, setFields] = React.useState([]);
  const [previewActive, setPreviewActive] = React.useState(false);
  const [activeGroupId, setActiveGroupId] = React.useState(FIELD_GROUPS[0]?.id || "layout");
  const [selectedFieldId, setSelectedFieldId] = React.useState(null);
  const [jsonDrafts, setJsonDrafts] = React.useState({});
  const [optionsDrafts, setOptionsDrafts] = React.useState({});
  const [formProps, setFormProps] = React.useState(DEFAULT_FORM_PROPS);
  const [currentFileHandle, setCurrentFileHandle] = React.useState(null);
  const [currentFileName, setCurrentFileName] = React.useState("");
  const [saveMessage, setSaveMessage] = React.useState("");
  const idCounter = React.useRef(1);
  const adderGroupIdRef = React.useRef(1);
  const adderGroupValueIdRef = React.useRef(1);
  const layoutTypes = React.useMemo(() => new Set(["layout-1", "layout-2", "layout-3", "layout-free"]), []);
  const formId = "__form__";
  const fileInputRef = React.useRef(null);
  const saveMessageTimerRef = React.useRef(null);

  function nextId() {
    const id = `field_${idCounter.current}`;
    idCounter.current += 1;
    return id;
  }

  function handleDropAt(index, data) {
    if (!data) return;
    if (data.source === "palette") {
      const item = FIELD_ITEM_MAP[data.itemId];
      if (!item) return;
      const nextField = buildFieldFromPalette(item, fields, nextId());
      if (shouldInheritAdderGroup(nextField)) {
        const inheritedGroup = findNextAdderGroup(fields, index);
        if (inheritedGroup) {
          nextField.adderGroup = inheritedGroup;
        }
      }
      let nextFields = [...fields];
      nextFields.splice(index, 0, nextField);
      if (nextField.type === "adder") {
        const groupValue = `adderGroup_${adderGroupValueIdRef.current}`;
        adderGroupValueIdRef.current += 1;
        nextFields = assignAdderGroupOnInsert(nextFields, index, groupValue);
      }
      setFields(nextFields);
      setSelectedFieldId(nextField._id);
      return;
    }
    if (data.source === "form") {
      const fromId = data.fieldId;
      if (!fromId) return;
      const fromIndex = fields.findIndex((field) => field._id === fromId);
      if (fromIndex < 0 || fromIndex >= fields.length) return;
      const nextFields = [...fields];
      let [moved] = nextFields.splice(fromIndex, 1);
      let targetIndex = index;
      if (fromIndex < index) {
        targetIndex -= 1;
      }
      if (shouldInheritAdderGroup(moved)) {
        const nextGroup = findNextAdderGroup(nextFields, targetIndex);
        if (nextGroup && moved && moved.adderGroup !== nextGroup) {
          moved = { ...moved, adderGroup: nextGroup };
        }
      }
      nextFields.splice(targetIndex, 0, moved);
      setFields(nextFields);
    }
  }

  function moveFieldById(sourceId, targetId) {
    if (!sourceId) return;
    const fromIndex = fields.findIndex((field) => field._id === sourceId);
    if (fromIndex === -1) return;
    let targetIndex = targetId ? fields.findIndex((field) => field._id === targetId) : fields.length;
    if (targetIndex === -1) {
      targetIndex = fields.length;
    }
    if (fromIndex === targetIndex) return;
    const nextFields = [...fields];
    const [moved] = nextFields.splice(fromIndex, 1);
    if (fromIndex < targetIndex) {
      targetIndex -= 1;
    }
    nextFields.splice(targetIndex, 0, moved);
    setFields(nextFields);
  }

  function moveFieldToTab(fieldId, tabId) {
    if (!fieldId || !tabId) return;
    const fromIndex = fields.findIndex((field) => field._id === fieldId);
    if (fromIndex === -1) return;
    const tabIndex = fields.findIndex((field) => field && field.type === "tab" && field._id === tabId);
    if (tabIndex === -1) return;
    let insertIndex = fields.length;
    for (let i = tabIndex + 1; i < fields.length; i += 1) {
      if (fields[i] && fields[i].type === "tab") {
        insertIndex = i;
        break;
      }
    }
    const nextFields = [...fields];
    const [moved] = nextFields.splice(fromIndex, 1);
    let targetIndex = insertIndex;
    if (fromIndex < insertIndex) {
      targetIndex -= 1;
    }
    nextFields.splice(targetIndex, 0, moved);
    setFields(nextFields);
    setSelectedFieldId(fieldId);
  }
  function removeFieldById(fieldId) {
    setFields((prev) => prev.filter((field) => field._id !== fieldId));
    if (selectedFieldId === fieldId) {
      setSelectedFieldId(null);
    }
  }

  function updateFieldById(fieldId, patch) {
    setFields((prev) =>
      prev.map((field) => {
        if (field._id !== fieldId) return field;
        return { ...field, ...patch };
      })
    );
  }

  function updateAdderGroupCascade(adderId, value) {
    const nextValue = String(value ?? "");
    setFields((prev) => {
      const adderIndex = prev.findIndex((field) => field && field._id === adderId);
      if (adderIndex === -1) return prev;
      let startIndex = 0;
      for (let i = adderIndex - 1; i >= 0; i -= 1) {
        const field = prev[i];
        if (field && field.type === "adder") {
          startIndex = i + 1;
          break;
        }
      }
      return prev.map((field, index) => {
        if (!field) return field;
        if (field._id === adderId) {
          if (field.adderGroup === nextValue) return field;
          return { ...field, adderGroup: nextValue };
        }
        if (index < startIndex || index >= adderIndex) return field;
        if (field.__adderGroupId || field.__adderClone) return field;
        if (!GROUP_FIELD_TYPES.has(field.type)) return field;
        if (field.adderGroup === nextValue) return field;
        return { ...field, adderGroup: nextValue };
      });
    });
  }

  function assignAdderGroupOnInsert(fieldsList, adderIndex, groupValue) {
    if (!groupValue) return fieldsList;
    let startIndex = 0;
    for (let i = adderIndex - 1; i >= 0; i -= 1) {
      const field = fieldsList[i];
      if (field && field.type === "adder") {
        startIndex = i + 1;
        break;
      }
    }
    return fieldsList.map((field, index) => {
      if (!field) return field;
      if (index < startIndex || index > adderIndex) return field;
      if (field.__adderGroupId || field.__adderClone) return field;
      if (!GROUP_FIELD_TYPES.has(field.type)) return field;
      if (field.adderGroup === groupValue) return field;
      return { ...field, adderGroup: groupValue };
    });
  }

  function readFileAsDataUrl(file) {
    if (!file) return Promise.resolve("");
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ""));
      reader.onerror = () => reject(reader.error || new Error("No se pudo leer el archivo"));
      reader.readAsDataURL(file);
    });
  }

  function triggerSavedMessage() {
    setSaveMessage("Correctamente grabado");
    if (saveMessageTimerRef.current) {
      clearTimeout(saveMessageTimerRef.current);
    }
    saveMessageTimerRef.current = setTimeout(() => {
      setSaveMessage("");
      saveMessageTimerRef.current = null;
    }, 2400);
  }

  function normalizeLoadedFields(rawFields) {
    if (!Array.isArray(rawFields)) return [];
    const nextId = deriveNextId(rawFields);
    let nextIdValue = nextId;
    const usedIds = new Set();
    const normalized = rawFields
      .map((field) => {
        if (!field || typeof field !== "object") return null;
        const nextField = { ...field };
        if (!nextField._id || usedIds.has(nextField._id)) {
          nextField._id = `field_${nextIdValue}`;
          nextIdValue += 1;
        }
        usedIds.add(nextField._id);
        return normalizeFieldBehaviours(normalizeFieldGroup(nextField));
      })
      .filter(Boolean);
    idCounter.current = nextIdValue;
    return normalized;
  }

  function parseFieldsFromRaw(raw) {
    if (!raw || typeof raw !== "object") return [];
    const direct = raw.fields;
    if (Array.isArray(direct)) return direct;
    if (typeof direct === "string" && direct.trim()) {
      try {
        const parsed = JSON.parse(direct);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }
    return [];
  }

  function normalizeExternalValue(externalValue) {
    if (externalValue === undefined || externalValue === null || externalValue === "") {
      return null;
    }
    if (typeof externalValue === "string") {
      try {
        const parsed = JSON.parse(externalValue);
        if (Array.isArray(parsed)) return { fields: parsed };
        if (parsed && typeof parsed === "object") return parsed;
        return null;
      } catch (error) {
        return null;
      }
    }
    if (Array.isArray(externalValue)) {
      return { fields: externalValue };
    }
    if (typeof externalValue === "object") {
      return externalValue;
    }
    return null;
  }

  function applyExternalValue(raw) {
    if (!raw || typeof raw !== "object") {
      setFormProps(DEFAULT_FORM_PROPS);
      setFields([]);
      setSelectedFieldId(null);
      setJsonDrafts({});
      setOptionsDrafts({});
      return;
    }
    const rawFormProps = raw.formProps && typeof raw.formProps === "object" ? raw.formProps : {};
    const nextFormProps = {
      ...DEFAULT_FORM_PROPS,
      ...stripFormProps(rawFormProps),
      submit: "true",
    };
    const parsedFields = parseFieldsFromRaw(raw);
    const nextFields = normalizeLoadedFields(parsedFields);
    setFormProps(nextFormProps);
    setFields(nextFields);
    setSelectedFieldId(null);
    setJsonDrafts({});
    setOptionsDrafts({});
  }

  function buildExportPayload() {
    return {
      formProps: { ...stripFormProps(formProps) },
      fields: fields.map((field) => sanitizeFieldForExport(field)),
    };
  }

  React.useEffect(() => {
    if (!onChange || !hasInitializedRef.current) return;
    const payload = buildExportPayload();
    const serialized = JSON.stringify(payload);
    if (serialized === lastEmittedRef.current) return;
    lastEmittedRef.current = serialized;
    externalValueRef.current = serialized;
    onChange(payload);
  }, [fields, formProps, onChange]);

  function applyLoadedData(raw, fileMeta = {}) {
    if (!raw || typeof raw !== "object") {
      window.alert("No se pudo abrir el archivo. JSON inválido.");
      return;
    }
    const rawFormProps = raw.formProps && typeof raw.formProps === "object" ? raw.formProps : {};
    const nextFormProps = {
      ...DEFAULT_FORM_PROPS,
      ...stripFormProps(rawFormProps),
      submit: "true",
    };
    const parsedFields = parseFieldsFromRaw(raw);
    const nextFields = normalizeLoadedFields(parsedFields);
    setFormProps(nextFormProps);
    setFields(nextFields);
    setSelectedFieldId(null);
    setJsonDrafts({});
    setOptionsDrafts({});
    if (fileMeta.handle) {
      setCurrentFileHandle(fileMeta.handle);
    } else {
      setCurrentFileHandle(null);
    }
    setCurrentFileName(fileMeta.name || "");
  }

  React.useEffect(() => {
    if (value === undefined) return;
    const normalized = normalizeExternalValue(value);
    const key = normalized ? JSON.stringify(normalized) : "";
    if (key && key === externalValueRef.current) return;
    externalValueRef.current = key;
    lastEmittedRef.current = key;
    if (normalized) {
      applyExternalValue(normalized);
    } else {
      setFormProps(DEFAULT_FORM_PROPS);
      setFields([]);
      setSelectedFieldId(null);
      setJsonDrafts({});
      setOptionsDrafts({});
    }
    hasInitializedRef.current = true;
  }, [value]);

  async function handleOpenClick() {
    if (typeof window !== "undefined" && window.showOpenFilePicker) {
      try {
        const [handle] = await window.showOpenFilePicker({
          types: [{ description: "JSON", accept: { "application/json": [".json"] } }],
          excludeAcceptAllOption: false,
          multiple: false,
        });
        if (!handle) return;
        const file = await handle.getFile();
        const text = await file.text();
        const parsed = JSON.parse(text);
        applyLoadedData(parsed, { handle, name: file.name });
        return;
      } catch (error) {
        if (error && error.name === "AbortError") return;
        window.alert("No se pudo abrir el archivo.");
        return;
      }
    }
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  }

  function handleOpenFileChange(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    file
      .text()
      .then((text) => {
        const parsed = JSON.parse(text);
        applyLoadedData(parsed, { name: file.name });
      })
      .catch(() => {
        window.alert("No se pudo abrir el archivo.");
      })
      .finally(() => {
        event.target.value = "";
      });
  }

  async function saveToHandle(handle, content) {
    const writable = await handle.createWritable();
    await writable.write(content);
    await writable.close();
  }

  function downloadJson(content, name = "formulario.json") {
    const blob = new Blob([content], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = name || "formulario.json";
    link.click();
    URL.revokeObjectURL(url);
  }

  async function handleSaveAsClick() {
    const content = JSON.stringify(buildExportPayload(), null, 2);
    if (typeof window !== "undefined" && window.showSaveFilePicker) {
      try {
        const handle = await window.showSaveFilePicker({
          suggestedName: currentFileName || "formulario.json",
          types: [{ description: "JSON", accept: { "application/json": [".json"] } }],
        });
        if (!handle) return;
        await saveToHandle(handle, content);
        setCurrentFileHandle(handle);
        setCurrentFileName(handle.name || currentFileName || "formulario.json");
        triggerSavedMessage();
        return;
      } catch (error) {
        if (error && error.name === "AbortError") return;
        window.alert("No se pudo guardar el archivo.");
        return;
      }
    }
    downloadJson(content, currentFileName || "formulario.json");
    setCurrentFileName(currentFileName || "formulario.json");
    triggerSavedMessage();
  }

  async function handleSaveClick() {
    const content = JSON.stringify(buildExportPayload(), null, 2);
    if (currentFileHandle) {
      try {
        await saveToHandle(currentFileHandle, content);
        triggerSavedMessage();
        return;
      } catch (error) {
        setCurrentFileHandle(null);
      }
    }
    await handleSaveAsClick();
  }

  React.useEffect(() => {
    return () => {
      if (saveMessageTimerRef.current) {
        clearTimeout(saveMessageTimerRef.current);
        saveMessageTimerRef.current = null;
      }
    };
  }, []);

  async function handleFormImageSelect(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    try {
      const dataUrl = await readFileAsDataUrl(file);
      setFormProps((prev) => ({ ...prev, icon_data_url: dataUrl }));
    } catch (error) {
      // ignore read errors
    } finally {
      event.target.value = "";
    }
  }

  async function handleImageViewSelect(fieldId, event) {
    const files = event.target.files ? Array.from(event.target.files) : [];
    if (!files.length) return;
    try {
      const dataUrls = await Promise.all(files.map((file) => readFileAsDataUrl(file)));
      const safeUrls = dataUrls.filter(Boolean);
      if (!safeUrls.length) return;
      updateFieldById(fieldId, { images: [...normalizeList(selectedField?.images), ...safeUrls] });
    } catch (error) {
      // ignore read errors
    } finally {
      event.target.value = "";
    }
  }

  function getDraftKey(fieldId, key) {
    return `${fieldId}:${key}`;
  }

  function getJsonDraft(fieldId, key, value) {
    const draftKey = getDraftKey(fieldId, key);
    if (jsonDrafts[draftKey] !== undefined) return jsonDrafts[draftKey];
    try {
      return JSON.stringify(value, null, 2);
    } catch (error) {
      return String(value ?? "");
    }
  }

  function handleJsonDraftChange(fieldId, key, raw) {
    const draftKey = getDraftKey(fieldId, key);
    setJsonDrafts((prev) => ({ ...prev, [draftKey]: raw }));
    try {
      const parsed = JSON.parse(raw);
      updateFieldById(fieldId, { [key]: parsed });
    } catch (error) {
      // keep draft until valid JSON
    }
  }

  function getOptionsDraft(fieldId, options) {
    const draftKey = getDraftKey(fieldId, "options");
    if (optionsDrafts[draftKey] !== undefined) return optionsDrafts[draftKey];
    return listToText(options);
  }

  function handleOptionsDraftChange(fieldId, raw) {
    const draftKey = getDraftKey(fieldId, "options");
    setOptionsDrafts((prev) => ({ ...prev, [draftKey]: raw }));
    updateFieldById(fieldId, { options: textToList(raw) });
  }

  const selectedIndex = fields.findIndex((field) => field._id === selectedFieldId);
  const selectedField = selectedIndex >= 0 ? fields[selectedIndex] : null;
  const prevField = selectedIndex > 0 ? fields[selectedIndex - 1] : null;
  const layoutBeforeSelected = prevField && layoutTypes.has(prevField.type);

  const activeGroup = FIELD_GROUPS.find((group) => group.id === activeGroupId) || FIELD_GROUPS[0];

  const handleProgramacionChange = React.useCallback((nextValue) => {
    setFormProps((prev) => {
      const prevKey = prev.scheduling_value ? JSON.stringify(prev.scheduling_value) : "";
      const nextKey = nextValue ? JSON.stringify(nextValue) : "";
      if (prevKey === nextKey) return prev;
      return { ...prev, scheduling_value: nextValue };
    });
  }, []);

  const handleNotificacionRulesChange = React.useCallback((nextRules) => {
    const nextValue = { rules: Array.isArray(nextRules) ? nextRules : [] };
    setFormProps((prev) => {
      const prevKey = prev.notification_value ? JSON.stringify(prev.notification_value) : "";
      const nextKey = JSON.stringify(nextValue);
      if (prevKey === nextKey) return prev;
      return { ...prev, notification_value: nextValue };
    });
  }, []);

  function handleBuilderFieldValueChange(fieldId, value) {
    if (!fieldId) return;
    updateFieldById(fieldId, { value: value });
  }
  function handleBuilderAdderClone(field) {
    if (!field || !field._id) return;
    setFields((prev) => {
      const groupId = `adder_${adderGroupIdRef.current}`;
      adderGroupIdRef.current += 1;
      const next = cloneFieldsForAdderBuilder(prev, field, groupId, nextId);
      return next || prev;
    });
  }
  function handleBuilderRemoveAdderGroup(groupId) {
    if (!groupId) return;
    setFields((prev) => {
      const removedIds = new Set();
      const filtered = prev.filter((field) => {
        if (field && field.__adderGroupId === groupId) {
          if (field._id) removedIds.add(field._id);
          return false;
        }
        return true;
      });
      if (selectedFieldId && removedIds.has(selectedFieldId)) {
        setSelectedFieldId(null);
      }
      return renumberBuilderCloneNames(filtered);
    });
  }

  function renderProperties() {
    if (selectedFieldId === formId) {
      const booleanProps = [
        { key: "header", label: "header" },
        { key: "card", label: "card" },
        { key: "close", label: "close" },
        { key: "editable", label: "editable" },
        { key: "scheduling", label: "scheduling" },
        { key: "notification", label: "notification" },
        { key: "dark", label: "dark" },
      ];
      const textProps = [
        { key: "title", label: "title" },
        { key: "subtitle", label: "subtitle" },
        { key: "scheduled_time", label: "scheduled_time" },
        { key: "color", label: "color" },
        { key: "background_color", label: "background_color" },
        { key: "height", label: "height" },
      ];
      const longTextProps = [
        { key: "icon_data_url", label: "icon_data_url" },
        { key: "html_header", label: "html_header" },
      ];
      return (
        <div className="space-y-3">
          <div className="grid gap-3">
            {textProps.map((prop) => (
              <FieldInput key={prop.key} label={prop.label}>
                {prop.key === "color" || prop.key === "background_color" ? (
                  <div className="flex items-center gap-2">
                    <input
                      type="color"
                      value={normalizeHexColor(formProps[prop.key] || "#000000")}
                      onChange={(event) => setFormProps((prev) => ({ ...prev, [prop.key]: event.target.value }))}
                      className="h-8 w-10 rounded border border-slate-200 bg-white p-0"
                    />
                    <input
                      type="text"
                      value={formProps[prop.key] ?? ""}
                      onChange={(event) => setFormProps((prev) => ({ ...prev, [prop.key]: event.target.value }))}
                      className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                    />
                  </div>
                ) : (
                  <input
                    type="text"
                    value={formProps[prop.key] ?? ""}
                    onChange={(event) => setFormProps((prev) => ({ ...prev, [prop.key]: event.target.value }))}
                    className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                  />
                )}
              </FieldInput>
            ))}
            <div className="grid gap-2 text-xs font-semibold text-slate-600">
              {booleanProps.map((prop) => (
                <label key={prop.key} className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={String(formProps[prop.key]).toLowerCase() === "true"}
                    onChange={(event) =>
                      setFormProps((prev) => ({ ...prev, [prop.key]: event.target.checked ? "true" : "false" }))
                    }
                  />
                  {prop.label}
                </label>
              ))}
            </div>
            {longTextProps.map((prop) => (
              <FieldInput key={prop.key} label={prop.label}>
                <div className="grid gap-2">
                  {prop.key === "icon_data_url" ? (
                    <input type="file" accept="image/*" onChange={handleFormImageSelect} className="text-xs" />
                  ) : null}
                  <textarea
                    rows={3}
                    value={formProps[prop.key] ?? ""}
                    onChange={(event) => setFormProps((prev) => ({ ...prev, [prop.key]: event.target.value }))}
                    className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                  />
                </div>
              </FieldInput>
            ))}
          </div>
        </div>
      );
    }
    if (!selectedField) {
      return (
        <div className="rounded-xl border border-dashed border-slate-200 p-4 text-center text-xs font-semibold text-slate-400">
          Selecciona un campo para editar sus propiedades
        </div>
      );
    }

    const canEditName =
      selectedField.name !== undefined ||
      !["layout-1", "layout-2", "layout-3", "layout-free", "tab", "divider", "videoview", "adder"].includes(selectedField.type);
    const canEditCaption =
      selectedField.caption !== undefined ||
      ![
        "layout-1",
        "layout-2",
        "layout-3",
        "layout-free",
        "tab",
        "divider",
        "title",
        "subtitle",
        "textView",
        "htmlview",
        "imageview",
        "videoview",
      ].includes(selectedField.type);
    const canEditRequired =
      selectedField.required !== undefined ||
      ![
        "layout-1",
        "layout-2",
        "layout-3",
        "layout-free",
        "tab",
        "divider",
        "title",
        "subtitle",
        "textView",
        "htmlview",
        "imageview",
        "videoview",
        "adder",
        "code",
      ].includes(selectedField.type);
    const canEditReadonly =
      selectedField.readonly !== undefined ||
      selectedField.readOnly !== undefined ||
      ![
        "layout-1",
        "layout-2",
        "layout-3",
        "layout-free",
        "tab",
        "divider",
        "title",
        "subtitle",
        "textView",
        "htmlview",
        "imageview",
        "videoview",
        "adder",
        "code",
      ].includes(selectedField.type);

    const showMaxLength =
      selectedField.maxLength !== undefined || selectedField.type === "text" || selectedField.type === "number";
    const showStep = selectedField.step !== undefined || selectedField.type === "number";
    const showInteger = selectedField.integer !== undefined || selectedField.type === "number";
    const showBehaviours = Boolean(selectedField.type);
    const showValue = VALUE_FIELD_TYPES.has(selectedField.type);
    const showGroup = GROUP_FIELD_TYPES.has(selectedField.type);
    const shownKeys = new Set(["_id", "type"]);
    if (canEditName) shownKeys.add("name");
    if (canEditCaption) shownKeys.add("caption");
    if (canEditRequired) shownKeys.add("required");
    if (selectedField.type === "adder") shownKeys.add("name");
    if (canEditReadonly) {
      shownKeys.add("readonly");
      shownKeys.add("readOnly");
    }
    if (showBehaviours) {
      shownKeys.add("behaviourUsuario");
      shownKeys.add("behaviourProfesional");
    }
    if (selectedField.placeholder !== undefined || selectedField.type === "options") shownKeys.add("placeholder");
    if (showMaxLength) shownKeys.add("maxLength");
    if (showStep) shownKeys.add("step");
    if (showInteger) shownKeys.add("integer");
    if (showGroup) shownKeys.add("adderGroup");
    if (TEXT_ONLY_TYPES.has(selectedField.type)) shownKeys.add("text");
    if (selectedField.type === "htmlview") shownKeys.add("html");
    if (selectedField.type === "tab") shownKeys.add("tab");
    if (OPTION_LIST_TYPES.has(selectedField.type)) shownKeys.add("options");
    if (IMAGE_LIST_TYPES.has(selectedField.type)) shownKeys.add("options");
    if (selectedField.type === "layout-free") shownKeys.add("options");
    if (selectedField.type === "imageview") {
      shownKeys.add("images");
      shownKeys.add("height");
      shownKeys.add("alignment");
      shownKeys.add("zoom");
    }
    if (selectedField.type === "videoview") {
      shownKeys.add("url");
      shownKeys.add("youtube");
      shownKeys.add("height");
    }
    if (selectedField.type === "image") shownKeys.add("source");
    if (selectedField.type === "video") shownKeys.add("seconds");
    if (selectedField.type === "attach") shownKeys.add("extensions");
    if (RANGE_TYPES.has(selectedField.type)) {
      shownKeys.add("minValue");
      shownKeys.add("maxValue");
    }
    if (VALUE_FIELD_TYPES.has(selectedField.type)) shownKeys.add("value");
    if (selectedField.type === "memo") shownKeys.add("dictation");
    if (selectedField.variant !== undefined || TEXT_ONLY_TYPES.has(selectedField.type)) shownKeys.add("variant");
    if (selectedField.type === "textView" || selectedField.type === "title" || selectedField.type === "subtitle") {
      shownKeys.add("alignment");
      shownKeys.add("color");
      shownKeys.add("fontSize");
      shownKeys.add("font-size");
    }

    const additionalEntries = Object.entries(selectedField).filter(([key, value]) => {
      if (shownKeys.has(key)) return false;
      if (key.startsWith("__adder")) return false;
      if (value === undefined) return false;
      return true;
    });

    const tabItems = fields
      .map((field) => {
        if (!field || field.type !== "tab") return null;
        const rawLabel = field.tab !== undefined ? field.tab : field.label;
        const label = typeof rawLabel === "string" ? rawLabel.trim() || "Pestaña" : rawLabel ? String(rawLabel) : "Pestaña";
        return { id: field._id, label };
      })
      .filter(Boolean);
    let currentTabId = null;
    if (selectedIndex >= 0) {
      for (let i = 0; i <= selectedIndex; i += 1) {
        const candidate = fields[i];
        if (candidate && candidate.type === "tab") {
          currentTabId = candidate._id;
        }
      }
    }
    const showTabSelector = selectedField.type !== "tab" && currentTabId && tabItems.length > 0;

    return (
      <div className="space-y-3">
        <div className="grid gap-3">
          {canEditName ? (
            <FieldInput label="nombre">
              <input
                type="text"
                value={selectedField.name || ""}
                onChange={(event) => updateFieldById(selectedField._id, { name: event.target.value })}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              />
            </FieldInput>
          ) : null}

          {canEditCaption ? (
            <FieldInput label="etiqueta">
              <input
                type="text"
                value={selectedField.caption || ""}
                onChange={(event) => updateFieldById(selectedField._id, { caption: event.target.value })}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              />
            </FieldInput>
          ) : null}

          {showGroup ? (
            <FieldInput label="grupo de adición">
              <input
                type="text"
                value={selectedField.adderGroup || ""}
                onChange={(event) => {
                  if (selectedField.type === "adder") {
                    updateAdderGroupCascade(selectedField._id, event.target.value);
                    return;
                  }
                  updateFieldById(selectedField._id, { adderGroup: event.target.value });
                }}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              />
            </FieldInput>
          ) : null}

          {showTabSelector ? (
            <FieldInput label="pestaña">
              <select
                value={currentTabId}
                onChange={(event) => moveFieldToTab(selectedField._id, event.target.value)}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              >
                {tabItems.map((tab) => (
                  <option key={tab.id} value={tab.id}>
                    {tab.label}
                  </option>
                ))}
              </select>
            </FieldInput>
          ) : null}

          {canEditRequired ? (
            <label className="flex items-center gap-2 text-xs font-semibold text-slate-600">
              <input
                type="checkbox"
                checked={Boolean(selectedField.required)}
                onChange={(event) => updateFieldById(selectedField._id, { required: event.target.checked })}
              />
              obligatorio
            </label>
          ) : null}

          {canEditReadonly ? (
            <label className="flex items-center gap-2 text-xs font-semibold text-slate-600">
              <input
                type="checkbox"
                checked={Boolean(selectedField.readonly ?? selectedField.readOnly)}
                onChange={(event) => {
                  const nextValue = event.target.checked;
                  const patch = { readonly: nextValue };
                  if (selectedField.readOnly !== undefined) {
                    patch.readOnly = undefined;
                  }
                  updateFieldById(selectedField._id, patch);
                }}
              />
              solo lectura
            </label>
          ) : null}

          {showBehaviours ? (
            <>
              <FieldInput label="Comportamiento Usuario">
                <select
                  value={normalizeBehaviourValue(selectedField.behaviourUsuario)}
                  onChange={(event) =>
                    updateFieldById(selectedField._id, { behaviourUsuario: normalizeBehaviourValue(event.target.value) })
                  }
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                >
                  {BEHAVIOUR_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </FieldInput>
              <FieldInput label="Comportamiento Profesional">
                <select
                  value={normalizeBehaviourValue(selectedField.behaviourProfesional)}
                  onChange={(event) =>
                    updateFieldById(selectedField._id, { behaviourProfesional: normalizeBehaviourValue(event.target.value) })
                  }
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                >
                  {BEHAVIOUR_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </FieldInput>
            </>
          ) : null}

          {selectedField.placeholder !== undefined || selectedField.type === "options" ? (
            <FieldInput label="marcador de posición">
              <input
                type="text"
                value={selectedField.placeholder || ""}
                onChange={(event) => updateFieldById(selectedField._id, { placeholder: event.target.value })}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              />
            </FieldInput>
          ) : null}

          {showValue ? (
            <FieldInput label="valor">
              {selectedField.type === "bool" ? (
                <label className="flex items-center gap-2 text-xs font-semibold text-slate-600">
                  <input
                    type="checkbox"
                    checked={isTrueValue(selectedField.value)}
                    onChange={(event) => updateFieldById(selectedField._id, { value: event.target.checked })}
                  />
                  verdadero / falso
                </label>
              ) : selectedField.type === "multiplelist" ? (
                <textarea
                  rows={3}
                  value={listToText(Array.isArray(selectedField.value) ? selectedField.value : [])}
                  onChange={(event) => updateFieldById(selectedField._id, { value: textToList(event.target.value) })}
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                />
              ) : selectedField.type === "memo" ? (
                <textarea
                  rows={3}
                  value={selectedField.value ?? ""}
                  onChange={(event) => updateFieldById(selectedField._id, { value: event.target.value })}
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                />
              ) : selectedField.value !== null && typeof selectedField.value === "object" ? (
                <textarea
                  rows={3}
                  value={getJsonDraft(selectedField._id, "value", selectedField.value)}
                  onChange={(event) => handleJsonDraftChange(selectedField._id, "value", event.target.value)}
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                />
              ) : (
                <input
                  type="text"
                  value={selectedField.value ?? ""}
                  onChange={(event) => updateFieldById(selectedField._id, { value: event.target.value })}
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                />
              )}
            </FieldInput>
          ) : null}

          {showMaxLength ? (
            <FieldInput label="longitud máxima">
              <input
                type="number"
                min="0"
                value={selectedField.maxLength ?? ""}
                onChange={(event) => {
                  const raw = event.target.value;
                  updateFieldById(selectedField._id, { maxLength: raw === "" ? undefined : Number(raw) });
                }}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              />
            </FieldInput>
          ) : null}

          {showStep ? (
            <FieldInput label="paso">
              <input
                type="text"
                value={selectedField.step ?? ""}
                onChange={(event) => {
                  const raw = event.target.value;
                  updateFieldById(selectedField._id, { step: raw === "" ? undefined : raw });
                }}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              />
            </FieldInput>
          ) : null}

          {showInteger ? (
            <label className="flex items-center gap-2 text-xs font-semibold text-slate-600">
              <input
                type="checkbox"
                checked={Boolean(selectedField.integer)}
                onChange={(event) => updateFieldById(selectedField._id, { integer: event.target.checked })}
              />
              entero
            </label>
          ) : null}

          {TEXT_ONLY_TYPES.has(selectedField.type) ? (
            <FieldInput label="texto">
              <input
                type="text"
                value={selectedField.text || ""}
                onChange={(event) => updateFieldById(selectedField._id, { text: event.target.value })}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              />
            </FieldInput>
          ) : null}

          {selectedField.type === "htmlview" ? (
            <FieldInput label="HTML">
              <textarea
                rows={4}
                value={selectedField.html || ""}
                onChange={(event) => updateFieldById(selectedField._id, { html: event.target.value })}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              />
            </FieldInput>
          ) : null}

          {selectedField.type === "tab" ? (
            <FieldInput label="pestaña">
              <input
                type="text"
                value={selectedField.tab || ""}
                onChange={(event) => updateFieldById(selectedField._id, { tab: event.target.value })}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              />
            </FieldInput>
          ) : null}

          {OPTION_LIST_TYPES.has(selectedField.type) ? (
            <FieldInput label="opciones (una por línea)">
              <textarea
                rows={4}
                value={getOptionsDraft(selectedField._id, selectedField.options)}
                onChange={(event) => handleOptionsDraftChange(selectedField._id, event.target.value)}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              />
            </FieldInput>
          ) : null}

          {IMAGE_LIST_TYPES.has(selectedField.type) ? (
            <FieldInput label="imágenes (una por línea)">
              <textarea
                rows={4}
                value={getOptionsDraft(selectedField._id, selectedField.options)}
                onChange={(event) => handleOptionsDraftChange(selectedField._id, event.target.value)}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              />
            </FieldInput>
          ) : null}

          {selectedField.type === "layout-free" ? (
            <FieldInput label="opciones (una por línea)">
              <textarea
                rows={4}
                value={getOptionsDraft(selectedField._id, selectedField.options)}
                onChange={(event) => handleOptionsDraftChange(selectedField._id, event.target.value)}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              />
            </FieldInput>
          ) : null}

          {selectedField.type === "imageview" ? (
            <FieldInput label="imágenes (una por línea)">
              <div className="grid gap-2">
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(event) => handleImageViewSelect(selectedField._id, event)}
                  className="text-xs"
                />
                <textarea
                  rows={4}
                  value={listToText(selectedField.images)}
                  onChange={(event) => updateFieldById(selectedField._id, { images: textToList(event.target.value) })}
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                />
              </div>
            </FieldInput>
          ) : null}

          {selectedField.type === "imageview" ? (
            <div className="grid gap-3">
              <FieldInput label="altura">
                <input
                  type="text"
                  value={selectedField.height || ""}
                  onChange={(event) => updateFieldById(selectedField._id, { height: event.target.value })}
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                />
              </FieldInput>
              <FieldInput label="alineación">
                <select
                  value={selectedField.alignment || ""}
                  onChange={(event) => updateFieldById(selectedField._id, { alignment: event.target.value || undefined })}
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                >
                  <option value="">predeterminado</option>
                  <option value="left">izquierda</option>
                  <option value="center">centro</option>
                  <option value="right">derecha</option>
                </select>
              </FieldInput>
              <label className="flex items-center gap-2 text-xs font-semibold text-slate-600">
                <input
                  type="checkbox"
                  checked={Boolean(selectedField.zoom)}
                  onChange={(event) => updateFieldById(selectedField._id, { zoom: event.target.checked })}
                />
                ampliación
              </label>
            </div>
          ) : null}

          {selectedField.type === "videoview" ? (
            <div className="grid gap-3">
              <FieldInput label="URL">
                <input
                  type="text"
                  value={selectedField.url || ""}
                  onChange={(event) => updateFieldById(selectedField._id, { url: event.target.value })}
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                />
              </FieldInput>
              <FieldInput label="YouTube">
                <input
                  type="text"
                  value={selectedField.youtube || ""}
                  onChange={(event) => updateFieldById(selectedField._id, { youtube: event.target.value })}
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                />
              </FieldInput>
              <FieldInput label="altura">
                <input
                  type="text"
                  value={selectedField.height || ""}
                  onChange={(event) => updateFieldById(selectedField._id, { height: event.target.value })}
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                />
              </FieldInput>
            </div>
          ) : null}

          {selectedField.type === "image" ? (
            <FieldInput label="origen">
              <select
                value={selectedField.source || "upload"}
                onChange={(event) => updateFieldById(selectedField._id, { source: event.target.value })}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              >
                <option value="upload">subir</option>
                <option value="camera">cámara</option>
              </select>
            </FieldInput>
          ) : null}

          {selectedField.type === "video" ? (
            <FieldInput label="segundos">
              <input
                type="number"
                min="1"
                value={selectedField.seconds || ""}
                onChange={(event) => updateFieldById(selectedField._id, { seconds: Number(event.target.value) || "" })}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              />
            </FieldInput>
          ) : null}

          {selectedField.type === "attach" ? (
            <FieldInput label="extensiones">
              <input
                type="text"
                value={selectedField.extensions || ""}
                onChange={(event) => updateFieldById(selectedField._id, { extensions: event.target.value })}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              />
            </FieldInput>
          ) : null}

          {RANGE_TYPES.has(selectedField.type) ? (
            <div className="grid gap-3">
              <FieldInput label="valor mínimo">
                <input
                  type="text"
                  value={selectedField.minValue || ""}
                  onChange={(event) => updateFieldById(selectedField._id, { minValue: event.target.value })}
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                  />
              </FieldInput>
              <FieldInput label="valor máximo">
                <input
                  type="text"
                  value={selectedField.maxValue || ""}
                  onChange={(event) => updateFieldById(selectedField._id, { maxValue: event.target.value })}
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                  />
              </FieldInput>
            </div>
          ) : null}

          {selectedField.type === "memo" ? (
            <label className="flex items-center gap-2 text-xs font-semibold text-slate-600">
              <input
                type="checkbox"
                checked={Boolean(selectedField.dictation)}
                onChange={(event) => updateFieldById(selectedField._id, { dictation: event.target.checked })}
              />
              dictado
            </label>
          ) : null}

          {selectedField.variant !== undefined || TEXT_ONLY_TYPES.has(selectedField.type) ? (
            <FieldInput label="variante">
              <select
                value={selectedField.variant || ""}
                onChange={(event) => updateFieldById(selectedField._id, { variant: event.target.value || undefined })}
                className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
              >
                <option value="">predeterminado</option>
                <option value="strong">fuerte</option>
                <option value="muted">atenuado</option>
                <option value="subtle">sutil</option>
              </select>
            </FieldInput>
          ) : null}

          {selectedField.type === "textView" || selectedField.type === "title" || selectedField.type === "subtitle" ? (
            <div className="grid gap-3">
              <FieldInput label="alineación">
                <select
                  value={selectedField.alignment || ""}
                  onChange={(event) => updateFieldById(selectedField._id, { alignment: event.target.value || undefined })}
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                >
                  <option value="">predeterminado</option>
                  <option value="left">izquierda</option>
                  <option value="center">centro</option>
                  <option value="right">derecha</option>
                </select>
              </FieldInput>
              <FieldInput label="color">
                <input
                  type="text"
                  value={selectedField.color || ""}
                  onChange={(event) => updateFieldById(selectedField._id, { color: event.target.value })}
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                  />
              </FieldInput>
              <FieldInput label="tamaño de fuente">
                <input
                  type="text"
                  value={selectedField.fontSize || selectedField["font-size"] || ""}
                  onChange={(event) => {
                    const nextValue = event.target.value;
                    const targetKey = selectedField.fontSize !== undefined ? "fontSize" : selectedField["font-size"] !== undefined ? "font-size" : "fontSize";
                    updateFieldById(selectedField._id, { [targetKey]: nextValue });
                  }}
                  className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                  />
              </FieldInput>
            </div>
          ) : null}

          {additionalEntries.length > 0 ? (
            <div className="grid gap-3">
              <p className="text-xs font-semibold uppercase text-slate-400">Otros</p>
              {additionalEntries.map(([key, value]) => {
                if (typeof value === "boolean") {
                  return (
                    <label key={key} className="flex items-center gap-2 text-xs font-semibold text-slate-600">
                      <input
                        type="checkbox"
                        checked={Boolean(value)}
                        onChange={(event) => updateFieldById(selectedField._id, { [key]: event.target.checked })}
                      />
                      {key}
                    </label>
                  );
                }
                if (typeof value === "number") {
                  return (
                    <FieldInput key={key} label={key}>
                      <input
                        type="number"
                        value={Number.isFinite(value) ? value : ""}
                        onChange={(event) => {
                          const raw = event.target.value;
                          updateFieldById(selectedField._id, { [key]: raw === "" ? undefined : Number(raw) });
                        }}
                        className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                      />
                    </FieldInput>
                  );
                }
                if (typeof value === "string") {
                  return (
                    <FieldInput key={key} label={key}>
                      <input
                        type="text"
                        value={value}
                        onChange={(event) => updateFieldById(selectedField._id, { [key]: event.target.value })}
                        className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                      />
                    </FieldInput>
                  );
                }
                return (
                  <FieldInput key={key} label={`${key} (JSON)`}>
                    <textarea
                      rows={4}
                      value={getJsonDraft(selectedField._id, key, value)}
                      onChange={(event) => handleJsonDraftChange(selectedField._id, key, event.target.value)}
                      className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm"
                    />
                  </FieldInput>
                );
              })}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  const showHeader = !hideHeader;
  const showToolbar = !hideToolbar;
  const wrapperClassName = `${embedded ? "h-full" : "h-screen"} overflow-hidden bg-slate-50 text-slate-800 ${className}`.trim();
  const containerClassName = `mx-auto flex h-full w-full ${embedded ? "max-w-none" : "max-w-[1600px]"} flex-col gap-4 p-4`;

  return (
    <div className={wrapperClassName} style={style}>
      <div className={containerClassName}>
        {showHeader ? (
          <header className="flex flex-wrap items-end justify-between gap-3">
            <div>
              <h1 className="text-xl font-semibold">Creador de formularios</h1>
              <p className="text-sm text-slate-500">Arrastra campos al formulario y edita sus propiedades.</p>
            </div>
            {showToolbar ? (
              <div className="flex items-center gap-2">
                {currentFileName ? (
                  <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600">
                    {currentFileName}
                  </span>
                ) : null}
                {saveMessage ? (
                  <span className="rounded-full bg-emerald-100 px-3 py-1 text-xs font-semibold text-emerald-700">
                    {saveMessage}
                  </span>
                ) : null}
                <button
                  type="button"
                  onClick={handleOpenClick}
                  className="rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-semibold text-slate-600 hover:bg-slate-50"
                >
                  Abrir
                </button>
                <button
                  type="button"
                  onClick={handleSaveClick}
                  className="rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-semibold text-slate-600 hover:bg-slate-50"
                >
                  Guardar
                </button>
                <button
                  type="button"
                  onClick={handleSaveAsClick}
                  className="rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-semibold text-slate-600 hover:bg-slate-50"
                >
                  Guardar como
                </button>
                <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600">
                  {fields.length} campo{fields.length === 1 ? "" : "s"}
                </span>
                <button
                  type="button"
                  onClick={() => {
                    setFields([]);
                    setSelectedFieldId(null);
                  }}
                  className="rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-semibold text-slate-600 hover:bg-slate-50"
                >
                  Limpiar
                </button>
              </div>
            ) : null}
          </header>
        ) : null}
        {showToolbar ? (
          <input
            ref={fileInputRef}
            type="file"
            accept="application/json,.json"
            onChange={handleOpenFileChange}
            className="hidden"
          />
        ) : null}

        <div className="grid flex-1 min-h-0 gap-4 lg:grid-cols-[320px_minmax(0,1fr)_320px]">
          <aside className="flex flex-col rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
            <div className="flex flex-wrap gap-2">
              {FIELD_GROUPS.map((group) => (
                <button
                  key={group.id}
                  type="button"
                  onClick={() => setActiveGroupId(group.id)}
                  className={`rounded-full px-3 py-1 text-xs font-semibold ring-1 transition ${
                    activeGroupId === group.id
                      ? "bg-slate-900 text-white ring-slate-900"
                      : "bg-white text-slate-600 ring-slate-200 hover:bg-slate-50"
                  }`}
                >
                  {group.title}
                </button>
              ))}
            </div>
            <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50 p-3">
              <h2 className="text-sm font-semibold text-slate-700">{activeGroup?.title}</h2>
              <p className="text-xs text-slate-500">{activeGroup?.description}</p>
              <div className="mt-3 grid gap-2">
                {activeGroup?.items.map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    draggable
                    onDragStart={(event) => {
                      event.dataTransfer.setData("text/plain", JSON.stringify({ source: "palette", itemId: item.id }));
                      event.dataTransfer.effectAllowed = "copy";
                    }}
                    className="flex items-center justify-between gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-left text-sm text-slate-700 shadow-sm transition hover:border-slate-300"
                  >
                    <span className="font-medium">{item.label}</span>
                    <span className="text-xs uppercase text-slate-400">{getTypeLabel(item.template.type)}</span>
                  </button>
                ))}
              </div>
            </div>
          </aside>

          <section className="flex min-h-0 flex-col gap-4 overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
            <div>
              <h2 className="text-sm font-semibold text-slate-700">Formulario</h2>
              <p className="text-xs text-slate-500">Arrastra campos desde la izquierda. Haz clic en el tirador para editar.</p>
            </div>

            <div
              onDragOver={(event) => {
                event.preventDefault();
                setPreviewActive(true);
              }}
              onDragLeave={() => setPreviewActive(false)}
              onDrop={(event) => {
                event.preventDefault();
                const data = parseDragData(event);
                handleDropAt(fields.length, data);
                setPreviewActive(false);
              }}
              className={`flex-1 overflow-y-auto rounded-xl border border-slate-200 bg-white p-3 transition ${
                previewActive ? "ring-2 ring-sky-300" : "ring-0"
              }`}
            >
              <div className="mx-auto w-full max-w-[416px]">
                <div className="w-full max-w-[360px]">
                  <FormCard
                    {...formProps}
                    fields={fields}
                    builderMode
                    builderSelectedId={selectedFieldId}
                    onBuilderSelectField={setSelectedFieldId}
                    onBuilderSelectForm={() => setSelectedFieldId(formId)}
                    onBuilderRemoveField={removeFieldById}
                    onBuilderMoveField={moveFieldById}
                    onBuilderDropAt={handleDropAt}
                    onProgramacionChange={handleProgramacionChange}
                    onNotificacionRulesChange={handleNotificacionRulesChange}
                    onBuilderFieldValueChange={handleBuilderFieldValueChange}
                    onBuilderAdderClone={handleBuilderAdderClone}
                    onBuilderRemoveAdderGroup={handleBuilderRemoveAdderGroup}
                    forceMobileNotifications
                  />
                </div>
              </div>
              {fields.length === 0 ? (
                <div className="mt-3 text-center text-xs font-semibold text-slate-400">Arrastra campos aquí</div>
              ) : null}
            </div>
          </section>

          <aside className="flex min-h-0 flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
            <h2 className="text-sm font-semibold text-slate-700">Propiedades</h2>
            <p className="text-xs text-slate-500">Edita el campo seleccionado.</p>
            <div className="mt-3">
              <FieldInput label="Campo">
                <select
                  value={selectedFieldId || ""}
                  onChange={(event) => setSelectedFieldId(event.target.value || null)}
                  className="w-full rounded-lg border border-slate-200 bg-white px-2 py-1 text-sm"
                >
                  <option value="">{fields.length === 0 ? "Sin campos" : "Selecciona un campo"}</option>
                  <option value={formId}>Formulario (FormCard)</option>
                  {fields
                    .filter((field) => !(field && field.__adderClone))
                    .map((field, index) => (
                      <option key={field._id || index} value={field._id || ""}>
                        {`${field.caption || getFieldLabel(field)} (${getTypeLabel(field.type)})`}
                      </option>
                    ))}
                </select>
              </FieldInput>
            </div>
            <div className="mt-4 min-h-0 flex-1 overflow-y-auto pr-1">{renderProperties()}</div>
            {layoutBeforeSelected ? (
              <button
                type="button"
                onClick={() => {
                  if (prevField?._id) {
                    removeFieldById(prevField._id);
                  }
                }}
                className="mt-3 w-full rounded-xl border border-red-200 bg-white px-3 py-2 text-sm font-semibold text-red-500 transition hover:bg-red-50"
              >
                Borrar diseño
              </button>
            ) : null}
            <button
              type="button"
              onClick={() => {
                if (selectedFieldId && selectedFieldId !== formId) {
                  removeFieldById(selectedFieldId);
                }
              }}
              disabled={!selectedFieldId || selectedFieldId === formId}
              className="mt-4 w-full rounded-xl border border-red-500 bg-red-500 px-3 py-2 text-sm font-semibold text-white transition hover:bg-red-600 disabled:cursor-not-allowed disabled:border-slate-200 disabled:bg-slate-100 disabled:text-slate-400"
            >
              Eliminar campo
            </button>
          </aside>
        </div>
      </div>
    </div>
  );
}

